import { useTheme } from "../../context/useThemeContext";
import ToggleIconButton from "../../components/buttons/toggleIconButton";
import { hexToRGBA } from "../../utility/hexToRGB";
import { FaChevronLeft, FaCloud, FaFolder, FaPlus } from "react-icons/fa6";
import useMainStore from "../../stores/mainStore";
import useDataStore from "../../stores/dataStore";
import { useAmtOfNotesInFolder } from "../leftSidebar";
import useAbsoluteWindowStore from "../../stores/absoluteWindowStore";
import TitleContextMenu from "../contextMenu/contextMenus/titleContextMenu";
import { ExportAllData, ImportAllData } from "../../utility/exportImportData";
import { ClearSoftwareData } from "../../utility/cache/clearAllCache";

function LeftHeader() {
    const { theme } = useTheme();
    const selectedFolderID = useMainStore(
        (state) => state.data.selectedFolderID
    );

    function addFolder() {
        useDataStore.getState().add.folder();
    }

    return (
        <div
            className="w-full h-[42px] flex items-center px-2  gap-[6px]  shrink-0 overflow-hidden"
            style={{
                backgroundColor: theme.headerColor,
            }}
        >
            {!selectedFolderID && (
                <div
                    className="flex flex-1 gap-[6px] pl-[36px] items-center h-[inherit]"
                    onContextMenu={(e) => {
                        e.preventDefault();
                        useAbsoluteWindowStore
                            .getState()
                            .setPosition(e.clientX, e.clientY);
                        useAbsoluteWindowStore.getState().setWindowShowing({
                            type: "ContextMenu",
                            children: (
                                <TitleContextMenu
                                    exportData={() => {
                                        ExportAllData();
                                    }}
                                    importData={() => {
                                        ImportAllData();
                                    }}
                                    deleteData={()=>{
                                        ClearSoftwareData(true);
                                    }}
                                />
                            ),
                        });
                    }}
                >
                    <FaCloud size={23} className="flex-shrink-0 mb-[2px]" />
                    <p className="font-bold flex flex-1 flex-shrink-0">
                        CloudNote
                    </p>
                    <ToggleIconButton
                        alt="Add new folder"
                        size={{ x: 28, y: 28 }}
                        icon={<FaPlus size={16} />}
                        inactiveIconColor={theme.fontColor[100]}
                        hoverIconInactive={theme.fontColor[50]}
                        hoverBGInactive={hexToRGBA(theme.fontColor[100], 0.2)}
                        onClick={() => {
                            addFolder();
                        }}
                    />
                </div>
            )}

            {selectedFolderID && (
                <div className="pl-[30px] flex flex-1">
                    <FolderSelectedContent id={selectedFolderID} />
                </div>
            )}
        </div>
    );
}

export default LeftHeader;

function FolderSelectedContent(props: { id?: string }) {
    const { theme } = useTheme();

    // Hooks
    const notesAMT = useAmtOfNotesInFolder(props.id);

    return (
        <div className="flex flex-1 items-center gap-1">
            <ToggleIconButton
                alt="Back to main view"
                size={{ x: 26, y: 26 }}
                icon={<FaChevronLeft size={14} />}
                hoverBGInactive={theme.secondaryHeaderColor}
                onClick={(e) => {
                    e.stopPropagation();
                    useMainStore
                        .getState()
                        .set.selectedFolderID((fn) => undefined);
                }}
            />
            <FolderDisplay id={props.id} />
            <p
                className="text-xs text-nowrap text-ellipsis overflow-hidden    "
                style={{
                    color: theme.fontColor[200],
                }}
            >
                {notesAMT} Notes
            </p>
        </div>
    );
}

function FolderDisplay(props: { id?: string }) {
    const { theme } = useTheme();

    // Store
    const folderColor = useDataStore((state) => {
        if (props.id)
            return (
                theme.accentColors[state.data.folders[props.id]?.color] ||
                theme.fontColor[100]
            );
        else return theme.fontColor[100];
    });

    // Store
    const folderName = useDataStore((state) => {
        if (props.id)
            return state.data.folders[props.id]?.name || "Uncategorized";
        else return "Uncategorized";
    });

    return (
        <>
            <div
                className="folderIcon flex w-[26px] h-[26px] items-center justify-center rounded mr-1  flex-shrink-0"
                style={{
                    backgroundColor: hexToRGBA(folderColor, 0.25),
                }}
            >
                <FaFolder
                    size={14}
                    style={{
                        color: folderColor,
                    }}
                />
            </div>
            <div className="flex flex-1 flex-shrink-1 overflow-hidden">
                <p
                    className="font-bold text-nowrap text-ellipsis overflow-hidden"
                    style={{
                        color: theme.fontColor[50],
                        whiteSpace: "nowrap",
                    }}
                >
                    {folderName}
                </p>
            </div>
        </>
    );
}
